(() => {
  if (window.spoiltGridViewControlsReady) return;
  window.spoiltGridViewControlsReady = true;

  const storageKey = 'spoilt-grid-columns';
  const allowedColumns = ['4', '5', '6'];
  const responsiveDefault = () => {
    if (window.innerWidth < 750) return '4';
    if (window.innerWidth < 990) return '4';
    return '5';
  };

  let columns = responsiveDefault();
  let userSelected = false;
  try {
    const saved = localStorage.getItem(storageKey);
    if (allowedColumns.includes(saved)) {
      columns = saved;
      userSelected = true;
    }
  } catch (_) {}

  const sync = () => {
    document.querySelectorAll('.spoilt-grid-view-page').forEach(root => {
      root.dataset.spoiltGridColumns = columns;

      root.querySelectorAll('#ProductGridContainer ul.product-grid').forEach(grid => {
        grid.classList.add('spoilt-grid-controlled');
        grid.dataset.spoiltColumns = columns;
        grid.style.setProperty('--spoilt-grid-columns', columns);
      });

      root.querySelectorAll('[data-spoilt-grid-columns]').forEach(button => {
        const pressed = button.dataset.spoiltGridColumns === columns;
        button.setAttribute('aria-pressed', String(pressed));
      });
    });
  };

  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-spoilt-grid-columns]');
    if (!button || !button.closest('.spoilt-grid-view-page')) return;

    const next = button.dataset.spoiltGridColumns;
    if (!allowedColumns.includes(next)) return;

    columns = next;
    userSelected = true;
    try { localStorage.setItem(storageKey, columns); } catch (_) {}
    sync();
  });

  const start = () => {
    sync();
    if (document.body) {
      const observer = new MutationObserver(scheduleSync);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  window.addEventListener('resize', () => {
    if (!userSelected) columns = responsiveDefault();
    scheduleSync();
  }, { passive: true });

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();